import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetOdometerValueRequest, GetOdometerValueResponse, PostEndVoucherRequest, GetActiveVoucherResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'finish-voucher.component.html',
  styleUrls: ['./finish-voucher.component.scss']
})
export class FinishVoucherComponent implements OnInit {

  odometerResponse: GetOdometerValueResponse | null = null;
  startOdometerValue: number = 0;
  startHours: number = 0;
  startMinutes: number = 0;
  workStartTime: Date | null = null;
  chosenDate: Date = new Date();
  isButtonDisabled: boolean = false;
  hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutes: number[] = Array.from({ length: 12 }, (_, i) => i * 5);
  comment: string = '';
  showPopup: boolean = false;
  popupMessage: string = 'odometr end value is invalid';
  loading: boolean = true;
  loadCounter: number = 0;
  isPopupVisible = false;
  isMobile: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadOdometer();
    this.loadComment();
    this.loadActiveVoucher();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  loadOdometer() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (activeVoucher) {
      const request: GetOdometerValueRequest = { carId: activeVoucher.carsId };
      this.courierService.getOdometrValue(request).subscribe((response: GetOdometerValueResponse) => {
        if (response) {
          this.odometerResponse = response;
          this.startOdometerValue = this.odometerResponse.odometerValue.odometerEndVal ?? 0;
          const currentTime = new Date();
          this.startHours = currentTime.getHours();
          this.startMinutes = Math.round(currentTime.getMinutes() / 5.0) * 5;

          if (this.startMinutes === 60) {
            this.startMinutes = 0;
            this.startHours = (this.startHours + 1) % 24;
          }
        } else {
          this.navigateToVoucher();
        }
        this.checkLoading();
      }, error => {
        console.error('Error fetching odometer value:', error);
        this.navigateToVoucher();
      });
    } else {
      this.navigateToVoucher();
    }
  }

  loadComment() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (activeVoucher) {
      const voucherId = activeVoucher.id;
      this.courierService.getComment({ voucherId }).subscribe(response => {
        if (response.comment.length > 0) {
          this.comment = response.comment[0].driverComment || '';
        } else {
          this.comment = '';
        }
        this.checkLoading();
      }, error => {
        console.error('Error fetching comments:', error);
        this.navigateToVoucher();
      });
    } else {
      this.navigateToVoucher();
    }
  }

  loadActiveVoucher() {
    const request = {};
    this.courierService.getActiveVouchers(request).subscribe((response: GetActiveVoucherResponse) => {
      if (response && response.voucher) {
        this.activeUserLocalDataService.setActiveCourierVoucher(response.voucher);
        this.workStartTime = response.voucher.workStartTime ? new Date(response.voucher.workStartTime) : null;
      } else {
        this.navigateToVoucher();
      }
      this.checkLoading();
    }, error => {
      console.error('Error fetching active voucher:', error);
      this.navigateToVoucher();
    });
  }

  checkLoading() {
    this.loadCounter++;
    if (this.loadCounter >= 3) {
      this.loading = false;
    }
  }

  dayBack() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() - 1);
    this.chosenDate = changedDate;
  }
  
  dayForward() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() + 1);
    this.chosenDate = changedDate;
  }
  finishVoucher() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (activeVoucher) {
      const finalDate = new Date(this.chosenDate);
      finalDate.setHours(this.startHours);
      finalDate.setMinutes(this.startMinutes);
  
      if (this.workStartTime && finalDate < this.workStartTime) {
        this.popupMessage = this.translateService.instant('EndTimeCannotBeBeforeWorkStartTimePleaseEnterAValidEndTime');
        this.showPopup = true;
        return;
      }
  
      const odometerDifference = this.startOdometerValue - (this.odometerResponse?.odometerValue.odometerEndVal || 0);
  
      if (odometerDifference > 1500) {
        this.popupMessage = this.translateService.instant('EnteredOdometerVlueExceeds1500KmPleaseEnterAValidOdometerValue');
        this.showPopup = true;
        return;
      }
  
      if (this.startOdometerValue > (this.odometerResponse?.odometerValue.odometerEndVal || 0)) {
        const request: PostEndVoucherRequest = {
          odometerEndVal: this.startOdometerValue,
          workEndTime: finalDate,
          driverComment: this.comment,
          voucherId: activeVoucher.id
        };
  
        this.courierService.postEnd(request).subscribe(() => {
          this.activeUserLocalDataService.setActiveCourierVoucher(null);
          this.router.navigate(['/voucher']);
        });
      } else {
        this.popupMessage = this.translateService.instant('PleaseEnterAValidOdometerValue');
        this.showPopup = true;
      }
    }
  }

  closePopup() {
    this.showPopup = false;
  }

  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }
}